<template>
  <!-- スプリットボタン -->
  <!-- 非活性時にツールチップを表示するようにするためにはButton=>Button2に変更してください -->
  <div class="cx_split_button">    
        <div class="cx_split_button_container" :class="{cx_appevent_enabled : eventEnabled}" ref="button">
            <!-- 通常のボタン-->
            <Button class="cx_split_button_primary" @click="onClick" :caption="caption" :icon="icon" :sc="sc" :tooltip="tooltip" :disabled="disabled" :perm="perm" :buttonStyle="buttonStyle" placement="topright"/>
            <!-- ドロップダウンボタン(非活性でもドロップダウンは有効化-->
            <div class="cx_dropdown" ref="dropdown" :tabindex="0" @click="onDropDown">
              <i class="material-icons small valign">arrow_drop_down</i>
            </div>
        </div>
        <!-- ポップアップ-->
        <div class="cx_popup" ref="popover" :tabindex="0"   boundary="window" placement="bottomleft"  v-if="showPopper">       
            <div class="cx_popup_container" :class="{cx_appevent_enabled : eventEnabled}" :style="{'min-width': $refs.button.clientWidth + 'px'}">
              <!-- アイコンなしで再掲する -->
              <Button class="cx_split_button_secondary" @click="onClick" :caption="caption"  :sc="sc" :tooltip="tooltip" :disabled="disabled" :perm="perm" :buttonStyle="buttonStyle"/> 
              <slot></slot>
            </div>
        </div>
  </div> 
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import Popper from 'popper.js';

@Component
export default class SplitButtion extends Vue {
  //buttonプロパティにリダイレクトする
  @Prop() public caption: string;
  @Prop() public icon: string;
  @Prop({default:null}) public sc: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:false}) public disabled: boolean;
  @Prop({default:null}) public perm: string;
  @Prop({default:null}) public buttonStyle: string;

  public eventEnabled :boolean = false;

  public mounted(){
    this.eventEnabled = this.$el.parentElement.classList.contains('cx_appevent_enabled');
  }
  public onClick(){
    this.$emit('click');
  }
  // ****** ポップアップ制御 *******
  public showPopper:boolean = false;
  public popperJS: Popper = null;

  public onShowPopup(){
    this.showPopper = true;
  }

  onDropDown(e:any) {
    if (this.showPopper) {
      this.onHide(e);
    } else {
      this.showPopper = true;
      //境界要素をcx_editorとする
      //popupはoverflow:hiddenが設定されている要素を越えられない。カットされるか領域が拡大されてしまう
      var target = this.$el.closest(".cx_editor");
      this.$nextTick(() => {
        const options = { placement:'bottom-end', modifiers:{preventOverflow:{boundariesElement:target}}};
        this.popperJS = new Popper(this.$refs.dropdown as HTMLElement, this.$refs.popover as HTMLElement, options as any);
        this.popperJS.enableEventListeners();        
        (this.$refs.popover as  HTMLElement).focus();
        (this.$refs.popover  as  HTMLElement).addEventListener('focusout', this.onFocusOut);        
        (this.$refs.popover  as  HTMLElement).addEventListener('click', this.onHide);                
      });
    }
  }
  
  onFocusOut(e:any) {
    //ポップアップもしくはドロップダウンのクリックはフォーカスバック
    if ((this.$refs.popover as HTMLElement).contains(e.relatedTarget) || (this.$refs.dropdown as HTMLElement).contains(e.relatedTarget) ) {
      (this.$refs.popover as  HTMLElement).focus();
      return;
    }
    this.onHide(e);
  }

  onHide(e:any) {
    //return;
    (this.$refs.popover as  HTMLElement).removeEventListener('focusout', this.onFocusOut);    
    (this.$refs.popover as  HTMLElement).removeEventListener('click', this.onHide); 

    this.showPopper = false;
    this.$nextTick(() => {
      if (this.popperJS) {
        this.popperJS.disableEventListeners();
        this.popperJS.destroy();
        this.popperJS = null;
      }
    });
  }
}
</script>
<style lang="scss">
.cx_split_button{
  .cx_split_button_container{
    display: flex;
    margin-left: 10px;
    .cx_button{
        //余分なマージンを取る
        margin-left: 0px !important;
        margin-right: 0px !important;        
        // 右側の境界線を消す
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;          
        border-right: none ;
        &:active:not(:disabled){
          border-right: none !important;        
        }      
    }
    .cx_dropdown{
      width :15px;
      display: flex;
      justify-content: center;
      padding-top: 5px;    
      user-select:none;

      //cx_buttonからコピー
      color: #444;
      border: 1px solid #acacac;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;    

      font-weight: 400;
      background: linear-gradient(to bottom, #f9f9f9 0, #e0e0e0 100%);
      // background: linear-gradient(to bottom, #eeeeee 0, #dfdfdf 100%);
      text-shadow: 0 1px 0 rgba(255, 255, 255, 1), 0 0 0 rgba(255, 255, 255, 0);
      box-shadow: none;
      white-space: nowrap;

      &:hover:not(:disabled){
        color: #444;
        border: 1px solid #bbb;
        background: linear-gradient(to bottom, #f6f6f6 0, #d4d4d4 100%);
        cursor: pointer;
      }
      &:active:not(:disabled){
        color: #444 !important;
        border: 1px solid #999 !important;
        background: linear-gradient(to bottom, #ececec 0, #c9c9c9 100%);
        box-shadow: none !important;
      }  
      &:focus{
        box-shadow: none !important;
      }
    }    
  }



  .cx_popup{
    z-index:100;
    padding: 1px 0px;
    .cx_popup_container{
      display:flex;
      flex-direction: column;
      background: #fff;
      border: 1px solid #ccc;
      padding: 5px 0px;
      .cx_split_button_secondary{
        width:100%;
        .cx_button{
          width: 100%;
        }
      }
      .cx_button{
        background:unset;
        text-shadow: unset;        
        border:none;
        border-radius: unset;
        text-align: start;
        margin-left: 0px;
        &:hover:not(:disabled){
          // color: #3194ff;
          border: none;
          background: #e9e9e9;
          cursor: pointer;
        }
        &:active:not(:disabled){
          // color: #3194ff !important;
          border: unset !important;
          background: #cccccc !important;
          box-shadow: none !important;
        }          
      }
    }
  }
}
</style>